import { PartnerPathInitialState } from "./ducks/PartnerPath";

/**
 * Fornece métodos estáticos para definição do estado inicial da aplicação.
 *
 * @since 0.0.1
 */
export class InitialState {
  /**
   * Retorna um objeto para uso em propriedades da store que necessitem de
   * sincronização periódica.
   *
   * @returns {Object}
   */
  static createSyncObject () {
    return {
      data: null,
      error: null,
      lastSync: null,
      pending: false,
      success: false
    };
  }

  /**
   * Retorna o estado inicial da interface da aplicação.
   *
   * @returns {Object}
   */
  static createInterfaceObject () {
    return {
      currentFeedbackFormId: null, 
      loading: false,
      loader: {
        visible: false,
        type: ""
      },
      menu: {
        visible: false
      },
      mobile: false,
      notifs: {
        visible: false
      },
      alerts: [],
      queue: [],
      recaptcha: null,
      recaptchaRequest: false,
      beautyProfile: false
    };
  }

  /**
   * Retorna o estado inicial da interface da aplicação.
   *
   * @returns {Object}
   */
  static createStateData () {
    return {
      currentSubscriber: null,
      currentEdition: null,
      isSubscriber: false, 
      isActiveSubscriber: false
    };
  }

  /**
   * Retorna um estado limpo para a aplicação.
   *
   * @returns {Object}
   */
  static create () {
    return {
      state: InitialState.createStateData(),
      
      // USER
      // ----------------------------------------------------------------
      token: InitialState.createSyncObject(),
      person: InitialState.createSyncObject(),
      subscribers: InitialState.createSyncObject(),
      editions: InitialState.createSyncObject(),
      notifs: InitialState.createSyncObject(),
      partnerInfo: InitialState.createSyncObject(),
      partnerGeneral: InitialState.createSyncObject(),
      partnerSales: InitialState.createSyncObject(),
      rewards: InitialState.createSyncObject(),
      beautyProfile: InitialState.createSyncObject(),
      payment: InitialState.createSyncObject(),
      creditCardInfo: InitialState.createSyncObject(),
      instagramInfo: InitialState.createSyncObject(),

      // INTERFACE
      // ----------------------------------------------------------------
      ui: InitialState.createInterfaceObject(),
      
      partnerCreate: PartnerPathInitialState()
    };
  }
}
